import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { MAILTO } from '../../utils/mailto';
function HexagonVisual() {
  return <div className="relative w-full max-w-lg mx-auto aspect-square" data-id="element-63">
      {/* Diagonal grid background */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.07]" aria-hidden="true" data-id="element-64">

        <defs data-id="element-65">
          <pattern id="coffee-grid" width="40" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(45)" data-id="element-66">

            <line x1="0" y1="0" x2="0" y2="40" stroke="#1B4332" strokeWidth="0.5" data-id="element-67" />

            <line x1="0" y1="0" x2="40" y2="0" stroke="#1B4332" strokeWidth="0.5" data-id="element-68" />

          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#coffee-grid)" data-id="element-69" />
      </svg>

      {/* Outer hexagon glow */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 400" aria-hidden="true" data-id="element-70">

        <defs data-id="element-71">
          <radialGradient id="hex-glow" cx="50%" cy="50%" r="50%" data-id="element-72">
            <stop offset="0%" stopColor="#52B788" stopOpacity="0.15" data-id="element-73" />
            <stop offset="100%" stopColor="#52B788" stopOpacity="0" data-id="element-74" />
          </radialGradient>
        </defs>
        <circle cx="200" cy="200" r="180" fill="url(#hex-glow)" data-id="element-75" />

        {/* Outer hexagon */}
        <polygon points="200,30 355,110 355,290 200,370 45,290 45,110" fill="none" stroke="#52B788" strokeWidth="1.5" opacity="0.3" data-id="element-76" />

        {/* Middle hexagon */}
        <polygon points="200,70 325,135 325,265 200,330 75,265 75,135" fill="none" stroke="#52B788" strokeWidth="1" opacity="0.2" data-id="element-77" />

        {/* Inner hexagon with fill */}
        <polygon points="200,110 295,160 295,240 200,290 105,240 105,160" fill="#52B788" fillOpacity="0.08" stroke="#52B788" strokeWidth="2" opacity="0.5" data-id="element-78" />


        {/* Connection dots on outer hexagon */}
        <circle cx="200" cy="30" r="5" fill="#52B788" opacity="0.6" data-id="element-79" />
        <circle cx="355" cy="110" r="4" fill="#9CA3AF" opacity="0.5" data-id="element-80" />
        <circle cx="355" cy="290" r="5" fill="#52B788" opacity="0.6" data-id="element-81" />
        <circle cx="200" cy="370" r="4" fill="#9CA3AF" opacity="0.5" data-id="element-82" />
        <circle cx="45" cy="290" r="5" fill="#52B788" opacity="0.6" data-id="element-83" />
        <circle cx="45" cy="110" r="4" fill="#9CA3AF" opacity="0.5" data-id="element-84" />

        {/* Small dots between vertices */}
        <circle cx="278" cy="70" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-85" />
        <circle cx="355" cy="200" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-86" />
        <circle cx="278" cy="330" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-87" />
        <circle cx="122" cy="330" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-88" />
        <circle cx="45" cy="200" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-89" />
        <circle cx="122" cy="70" r="3" fill="#9CA3AF" opacity="0.4" data-id="element-90" />
      </svg>

      {/* Center coffee emoji/icon */}
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-91">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/3zho3j7rbfxjzyaqujg3yf/bf50139a-25ca-4767-a015-2905f784a570/coffee_transparent.png" alt="Coffee cup" className="w-32 h-32 object-contain" data-id="element-92" />

      </div>

      {/* Floating node badges */}
      <motion.div className="absolute top-6 left-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-carbon-bright flex items-center justify-center shadow-lg shadow-carbon-bright/30" animate={{
      y: [0, -6, 0]
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-93">

        <span className="text-white text-lg" data-id="element-94">🌱</span>
      </motion.div>

      <motion.div className="absolute bottom-16 right-4 w-12 h-12 rounded-full bg-carbon-deep flex items-center justify-center shadow-lg" animate={{
      y: [0, 6, 0]
    }} transition={{
      duration: 3.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.5
    }} data-id="element-95">

        <span className="text-white text-lg" data-id="element-96">🔍</span>
      </motion.div>

      <motion.div className="absolute bottom-8 left-8 w-11 h-11 rounded-full bg-carbon-bright/90 flex items-center justify-center shadow-lg shadow-carbon-bright/30" animate={{
      y: [0, -5, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} data-id="element-97">

        <span className="text-white text-lg" data-id="element-98">📦</span>
      </motion.div>
    </div>;
}
export function CoffeeHero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-99">
      {/* Subtle diagonal grid across full section */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.04]" aria-hidden="true" data-id="element-100">

        <defs data-id="element-101">
          <pattern id="hero-grid" width="50" height="50" patternUnits="userSpaceOnUse" patternTransform="rotate(45)" data-id="element-102">

            <line x1="0" y1="0" x2="0" y2="50" stroke="#1B4332" strokeWidth="0.5" data-id="element-103" />

            <line x1="0" y1="0" x2="50" y2="0" stroke="#1B4332" strokeWidth="0.5" data-id="element-104" />

          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hero-grid)" data-id="element-105" />
      </svg>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36" data-id="element-106">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-107">
          {/* Left: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-108">

            <p className="text-sm font-semibold uppercase tracking-widest text-carbon-bright mb-4" data-id="element-109">
              Coffee Traceability | Uganda
            </p>
            <h1 className="text-[3.5rem] font-bold text-carbon-deep tracking-tight leading-[1.1]" data-id="element-110">
              Your Only Source Of Truth For{' '}
              <span className="relative inline-block" data-id="element-111">
                <span className="relative z-10" data-id="element-112">Transparent</span>
                <span className="absolute bottom-1 left-0 right-0 h-[40%] bg-carbon-bright/25 -z-0 rounded-sm" aria-hidden="true" data-id="element-113" />

              </span>{' '}
              Coffee Supply Chains
            </h1>
            <p className="mt-6 text-lg text-carbon-deep leading-relaxed max-w-xl" data-id="element-114">
              From Uganda's Mt. Elgon highlands to global markets, CarbonSafe
              connects every data point in the coffee supply chain: origin,
              processing, carbon footprint, and EUDR compliance, all in one
              real-time, verifiable platform.
            </p>

            {/* Compliance badges inspired by CarbonScan.ai */}
            <div className="mt-5 flex flex-wrap gap-3" data-id="element-115">
              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-[#9aa6af] bg-white text-sm font-medium text-carbon-deep" data-id="element-116">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-117" />
                EUDR Compliant
              </span>
              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-[#9aa6af] bg-white text-sm font-medium text-carbon-deep" data-id="element-118">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-119" />
                UCDA Certified
              </span>
              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-[#9aa6af] bg-white text-sm font-medium text-carbon-deep" data-id="element-120">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-121" />
                GHG Protocol
              </span>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-122">
              <a href={MAILTO.coffeeDemo} className="inline-flex items-center gap-2 px-7 py-3.5 bg-carbon-bright text-white text-base font-semibold rounded-lg hover:bg-carbon-light transition-colors shadow-lg shadow-carbon-bright/20" data-id="element-123">

                See CarbonSafe in action
                <ArrowRightIcon className="w-4 h-4" data-id="element-124" />
              </a>
              <a href={MAILTO.coffeePlatform} className="inline-flex items-center gap-2 px-7 py-3.5 border border-[#2d3c48] text-carbon-deep text-base font-semibold rounded-lg hover:bg-carbon-bright/5 transition-colors" data-id="element-125">

                Explore The Platform
              </a>
            </div>
          </motion.div>

          {/* Right: Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-126">

            <HexagonVisual data-id="element-127" />
          </motion.div>
        </div>
      </div>
    </section>;
}